<pagination (pageChanged)="onPageChange($event)" [(ngModel)]="currentPage" [boundaryLinks]="true"
  [totalItems]="totalRecords" [itemsPerPage]="perPage" [maxSize]="5" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
  lastText="&raquo;">